import React from "react";
import ReactDOMServer from "react-dom/server";
import { QRCodeSVG } from "qrcode.react";

export const gerarQrCodePng = (texto: string, tamanho = 512): Promise<string | null> =>
    new Promise((resolve) => {
        if (!texto) {
            resolve(null);
            return;
        }
        try {
            const svgBruto = ReactDOMServer.renderToStaticMarkup(
                React.createElement(QRCodeSVG, { value: texto, size: tamanho, level: "M", includeMargin: true })
            );
            const svg = svgBruto.includes("xmlns=")
                ? svgBruto
                : svgBruto.replace("<svg", '<svg xmlns="http://www.w3.org/2000/svg"');
            const img = new Image();
            img.onload = () => {
                try {
                    const canvas = document.createElement("canvas");
                    canvas.width = tamanho;
                    canvas.height = tamanho;
                    const contexto = canvas.getContext("2d");
                    if (!contexto) {
                        resolve(null);
                        return;
                    }
                    contexto.fillStyle = "#FFFFFF";
                    contexto.fillRect(0, 0, tamanho, tamanho);
                    contexto.drawImage(img, 0, 0, tamanho, tamanho);
                    resolve(canvas.toDataURL("image/png"));
                } catch {
                    resolve(null);
                }
            };
            img.onerror = () => resolve(null);
            img.src = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svg)))}`;
        } catch {
            resolve(null);
        }
    });
